import { filterObjectOnKeys } from "@utils/helpers";
import Vue from "vue";

const availableProps = {
  absolute: Boolean,
  bottom: Boolean,
  fixed: Boolean,
  left: Boolean,
  right: Boolean,
  top: Boolean
};

export function factory(selected = []) {
  return Vue.extend({
    name: "Positionable",
    props: selected.length
      ? filterObjectOnKeys(availableProps, selected)
      : availableProps
  });
}

export default factory();
